import { memo, useState } from "react";
import { ShareIcon } from "./assets/share.icon";
import { TelegramIcon } from "./assets/telegram.icon";
import { TwitterIcon } from "./assets/twitter.icon";
import { LinkIcon } from "./assets/link.icon";
import { WhatsAppIcon } from "./assets/whatsapp.icon";
import * as Sentry from "@sentry/nextjs";
import { ArrowSuccessIcon } from "./assets/arrow-succes.icon";

type ShareAction = (url: string, text: string) => string;

interface ShareButtonsLinkProps {
  copyText: string;
  copiedText: string;
  shareText: string;
}

const socialNetworks = [
  {
    name: "Telegram",
    icon: TelegramIcon,
    action: (url: string, text: string) =>
      `https://t.me/share/url?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(text)}`,
  },
  {
    name: "WhatsApp",
    icon: WhatsAppIcon,
    action: (url: string, text: string) =>
      `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`,
  },
  {
    name: "Twitter",
    icon: TwitterIcon,
    action: (url: string, text: string) => {
      const via = "guidedao";
      const hashtags = "guidedao,crypto,web3";
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(url)}&via=${encodeURIComponent(
        via
      )}&hashtags=${encodeURIComponent(hashtags)}`;
    },
  },
];

export const ShareButtonsLink = memo<ShareButtonsLinkProps>(
  ({ copyText, copiedText, shareText }) => {
    function copyToClipboard() {
      navigator.clipboard
        .writeText(window.location.href)
        .then(() => {
          setIsLinkCopied(true);
        })
        .catch((err) => {
          Sentry.captureException(
            `Ошибка при копировании ссылки блога: ${err}`
          );
        });
    }

    const handleShare = (action: ShareAction) => {
      const url = window.location.href;
      const text = "Check out this article on the Guide DAO blog!";
      window.open(action(url, text), "_blank");
    };

    const [isShown, setIsShown] = useState(false);
    const [isLinkCopied, setIsLinkCopied] = useState(false);
    return (
      <div className="relative">
        <div
          onClick={() => setIsShown(!isShown)}
          className="cursor-pointer flex items-center text-[20px] leading-[124%]"
        >
          <div className="flex items-center justify-center bg-day-base-base-100 h-[48px] w-[48px] rounded-[14px]">
            <ShareIcon />
          </div>
          <div className="pl-10">{shareText}</div>
        </div>
        {isShown && (
          <div className="absolute top-[48px] z-10 bg-white left-[0px] rounded-[12px] mt-8 border border-solid border-day-base-base-100 max-w-max pt-10 px-12 pb-0 md:pt-5 md:pb-2 md:px-8">
            {socialNetworks.map(({ name, icon: Icon, action }, index) => (
              <div
                key={index}
                onClick={() => handleShare(action)}
                className="cursor-pointer flex items-center mb-10 md:mb-4"
              >
                <div className="mr-5 flex items-center justify-center bg-day-base-base-100 h-[24px] w-[24px] rounded-[5px]">
                  <Icon />
                </div>
                <div>{name}</div>
              </div>
            ))}
            <div
              onClick={copyToClipboard}
              className="cursor-pointer flex items-center mb-10 md:mb-4"
            >
              {isLinkCopied ? (
                <>
                  <div className="mr-5 flex items-center justify-center bg-green bg-opacity-10 h-[24px] w-[24px] rounded-[5px]">
                    <ArrowSuccessIcon />
                  </div>
                  <div>{copiedText}</div>
                </>
              ) : (
                <>
                  <div className="mr-5 flex items-center justify-center bg-day-base-base-100 h-[24px] w-[24px] rounded-[5px]">
                    <LinkIcon />
                  </div>
                  <div>{copyText}</div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
);
